import React from 'react'

export default function Footer() {
  return (
    <footer className="footer">
      <p className='footer-copy'>&copy;{new Date().getFullYear()} Designed & Built by Dinar Davis</p>
    </footer>
  )
}